import { ApplicationNames } from "@telstra-connect/utils/data/platform-data";

/**
 * Enum defining the available BVT (Business Value Test) feature flags.
 * These flags are used to control the visibility and behavior of features
 * that are under testing or development for specific customer segments.
 *
 * **Important: You cannot hardcode bvt flag names in your code**
 */
export enum BvtFeatureFlags {
    /**
     * Feature flag for enabling the single UI raise incident feature (TEDIG-7938).
     * This flag determines whether the new single UI for raising incidents is enabled for a user.
     */
    tedig7938SingleUiRaiseIncident = "tedig7938SingleUiRaiseIncident",
    /**
     * Feature flag for enabling the single UI track incident part 1 feature (TEDIG-8377).
     * This flag controls the availability of the first part of the new single UI for tracking incidents.
     */
    tedig8377SingleUiTrackIncidentPart1 = "tedig8377SingleUiTrackIncidentPart1"
}

export interface IFeatureFlagWithBVT {
    bvtEnabledFeature: boolean,
    flagState: boolean
}

export type FlagApplicationNames = ApplicationNames;

export interface IUseBvtFlagsCheckerProps {
    bvtFlagName: BvtFeatureFlags;
    cidn?: string;
    appName?: FlagApplicationNames;
}
